import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import { slugify } from '../../helpers';

import FiltersResetButton from './FiltersResetButton';

class FiltersFileExtensions extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  handleChangeFilter(e) {
    const {
      checked,
      value,
    } = e.target;
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;
    let { extensions: newSelected } = filters;
    if (checked) {
      newSelected.push(value);
      addFilter({
        type: 'extensions',
        key: `${value}`,
        label: value.toUpperCase(),
        title: intl.formatMessage({ defaultMessage: 'Extension' }),
      });
    } else {
      newSelected = newSelected.filter(s => (s !== value));
      removeFilter('extensions', value);
    }
    handleChangeFilters({ extensions: newSelected });
  }

  handleReset() {
    const {
      handleChangeFilters,
      clearSelectedFilters,
    } = this.props;
    handleChangeFilters({ extensions: [] });
    clearSelectedFilters('extensions');
  }

  render() {
    const {
      intl,
      isOpen,
      availableFilters,
      filters,
      handleToggleFilter,
      prefix,
    } = this.props;
    const selected = filters.extensions;

    if (availableFilters.length === 0) {
      return null;
    }

    return (
      <div className="files-filter file-extension-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'File extension' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form file-extension-filter-form">
            {availableFilters.filter(ft => (ft.key !== '')).map(ft => (
              <FormGroup key={`fileextension-${slugify(ft.key)}`}>
                <Label for={`${prefix}checkFileExtension-${slugify(ft.key)}`} check>
                  <Input
                    type="checkbox"
                    name="fileType"
                    id={`${prefix}checkFileExtension-${slugify(ft.key)}`}
                    className="input-check check-s"
                    value={ft.key}
                    checked={selected.find(s => (s === ft.key)) || false}
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    {ft.key.toUpperCase()}
                  </span>
                </Label>
              </FormGroup>
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  filters: props.customFilters || state.Files.filters,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
  }),
  clearSelectedFilters: props.customClearSelectedFilters || ((filterType) => {
    dispatch(deleteSelectedFilter(filterType, null));
  }),
});

FiltersFileExtensions.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  availableFilters: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  prefix: PropTypes.string,
};

FiltersFileExtensions.defaultProps = {
  prefix: '',
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersFileExtensions));
